module.exports = __webpack_public_path__ + "media/images/features/draft/icon-flow-04-0637a03d1232de965572055f24962d49.svg";